<template>
    <ModalFormCard class="modal-default" :action='"/admin/company/" + company.id'>
        <template #title>Edit {{ company.name }}</template>

        <template #default="{ saving, errors }">

            <Input
                v-model:value="value.legal_name"
                groupClass="bg-grey text-15"
                label="Company registration name"
                name="legal_name"
                placeholder="Company registration name"
            >
                <template #right>
                    <Tooltip text="This is the name registered with Companies House. It is also used on customer invoices." />
                </template>
            </Input>

            <Input
                v-model:value="value.ad_name"
                class="mt-4"
                groupClass="bg-grey text-15"
                label="Company advertising name"
                name="ad_name"
                placeholder="Company advertising name"
            >
                <template #right>
                    <Tooltip text="This is the name used on our customer's landing page and within their ads. It is also used to buy domain names." />
                </template>
            </Input>

            <Input
                v-model:value="value.name"
                class="mt-4"
                groupClass="bg-grey text-15"
                label="Company trading name"
                name="name"
                placeholder="Company trading name"
            >
                <template #right>
                    <Tooltip text="This is the name used by our customer to market their services to the public. We use this name throughout the system." />
                </template>
            </Input>

            <Input
                v-model:value="value.name_short"
                class="mt-4"
                groupClass="bg-grey text-15"
                label="Company short name"
                name="name_short"
                placeholder="Company short name"
            >
                <template #right>
                    <Tooltip text="This is an abbreviated name that's used on our customer's landing page." />
                </template>
            </Input>

            <Input
                v-model:value="value.address_line_1"
                class="mt-4"
                groupClass="bg-grey text-15"
                label="Address"
                name="address_line_1"
                placeholder="Line 1"
            />
            <Input
                v-model:value="value.address_line_2"
                class="mt-1"
                groupClass="bg-grey text-15"
                name="address_line_2"
                placeholder="Line 2"
            />
            <Input v-model:value="value.town" class="mt-1" groupClass="bg-grey text-15" name="town" placeholder="City / town" />
            <Input
                v-model:value="value.postcode"
                class="mt-1"
                groupClass="bg-grey text-15"
                name="postcode"
                placeholder="Post code"
            />

            <Input
                v-model:value="value.contact_number_1"
                class="mt-4"
                groupClass="bg-grey text-15"
                label="Business phone"
                name="contact_number_1"
                placeholder="Business phone"
            />

            <Select
                v-model:value="value.industry_id"
                :options="industries"
                placeholder="Industry"
                class="mt-4"
                label="Industry"
                menuClass="!bg-grey"
                name="industry_id"
                selectClass="!bg-grey text-15"
                forceDirection="bottom"
            />

            <Select
                v-model:value="value.prospect_sales_user_id"
                :options="users"
                placeholder="Prospect asigned to"
                class="mt-4"
                label="Prospect asigned to"
                menuClass="!bg-grey"
                name="prospect_sales_user_id"
                selectClass="!bg-grey text-15"
                forceDirection="bottom"
            />

            <Select
                v-model:value="value.sold_by_user_id"
                :options="users"
                placeholder="Sold by"
                class="mt-4"
                label="Sold by"
                menuClass="!bg-grey"
                name="sold_by_user_id"
                selectClass="!bg-grey text-15"
                forceDirection="bottom"
            />

            <Select
                v-model:value="value.support_user_id"
                :options="users"
                placeholder="Support user"
                class="mt-4"
                label="Support assigned to"
                menuClass="!bg-grey"
                name="support_user_id"
                selectClass="!bg-grey text-15"
                forceDirection="bottom"
            />

            <div class="modal-buttons pt-6">
				<ButtonSaving :disabled="saving" class="default button-black h-12 px-6">
					Update company
				</ButtonSaving>
            </div>
            
        </template>
    </ModalFormCard>
</template>

<script>
    import Modal from '~/mixins/modal.js'
    import Company from '~/models/company.js'

    export default {
        mixins: [Modal],

        created() {
            this.setup(Company, this.editingModel);
            this.value.contact_number_1 = this.$help.e164ToNumber(this.value.contact_number_1, false, false)
        },

        computed: {
            company() {
                return this.editingModel
            },

            industries() {
                return [
                    { value: 1, html: 'Roofing' },
                    { value: 2, html: 'Joinery' },
                    { value: 3, html: 'Electrical' },
                    { value: 4, html: 'Plastering' },
                    { value: 5, html: 'Building' },
                    { value: 6, html: 'Landscaping' },
                    { value: 7, html: 'Decorating' },
                    { value: 8, html: 'Plumbing' },
                    { value: 9, html: 'Rendering' },
                    { value: 10, html: 'Driveways' },
                    { value: 11, html: 'Heating' },
                    { value: 12, html: 'Loft Conversions' }
                ]
            },

            users() {
                return this.$help.adminUsers()
            }
        }
    }
</script>